(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hbni-product-details"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-hbni-description]').forEach(root=>{root.querySelectorAll('p').forEach(p=>{const lines=p.innerHTML.split(/<br\s*\/?\s*>/i).map(s=>s.trim()).filter(Boolean);if(lines.length&&lines.every(s=>/^[-–]\s|^\.:\s/.test(s))){const ul=document.createElement('ul');lines.forEach(s=>{const li=document.createElement('li');li.innerHTML=s.replace(/^[-–]\s*|^\.:\s*/,'');ul.append(li)});p.replaceWith(ul)}})});
  } catch(e) { console.error(e); }
})();

})();
